import {
  POPULATE_STUDENT_GOALS,
  POPULATE_POSSIBLE_STUDENT_CAREER_GOALS,
  SET_POSSIBLE_STUDENT_CAREER_GOALS_LOADING,
  GET_GOAL_COLLEGES,
  SET_GOAL_COLLEGES,
  GET_GOAL_MAJORS,
  SET_GOAL_MAJORS,
  CLEAR_GOAL_MAJORS,
  CLEAR_GOAL_COLLEGES,
} from 'constants/studentGoals';

const initialState = {
  selectionByStudentId: {}, // also contains 'me'
  collegeSearchResults: {
    colleges: [],
    isLoading: true,
  },
  careerSearchResults: {
    isLoading: true,
    militaryCareers: [],
    civilianCareers: [],
  },
  goalMajors: {
    majors: [],
    isLoading: false,
  },
};

export default function studentGoals(state = initialState, action) {
  switch (action.type) {
    case POPULATE_STUDENT_GOALS:
      return {
        ...state,
        selectionByStudentId: {
          ...state.selectionByStudentId,
          [action.studentId]: action.careerGoalsSelection
            ? {
                ...state.selectionByStudentId[action.studentId],
                careerGoals: action.careerGoalsSelection,
              }
            : action.selection,
        },
      };
    case GET_GOAL_COLLEGES:
      return {
        ...state,
        collegeSearchResults: {
          colleges: [],
          isLoading: true,
        },
      };
    case SET_GOAL_COLLEGES:
      return {
        ...state,
        collegeSearchResults: {
          colleges: action.goalColleges,
          isLoading: false,
        },
      };
    case CLEAR_GOAL_COLLEGES:
      return {
        ...state,
        collegeSearchResults: {
          colleges: [],
          isLoading: true,
        },
      };
    case SET_POSSIBLE_STUDENT_CAREER_GOALS_LOADING:
      return {
        ...state,
        careerSearchResults: {
          isLoading: true,
        },
      };

    case POPULATE_POSSIBLE_STUDENT_CAREER_GOALS:
      return {
        ...state,
        careerSearchResults: {
          isLoading: action.isLoading,
          militaryCareers: action.militaryCareers,
          civilianCareers: action.civilianCareers,
        },
      };
    case GET_GOAL_MAJORS:
      return {
        ...state,
        goalMajors: {
          isLoading: true,
          majors: [],
        },
      };
    case SET_GOAL_MAJORS:
      return {
        ...state,
        goalMajors: {
          isLoading: false,
          majors: action.goalMajors,
        },
      };
    case CLEAR_GOAL_MAJORS:
      return {
        ...state,
        goalMajors: {
          isLoading: false,
          majors: [],
        },
      };
    default:
      return state;
  }
}
